import { apiRequest } from "../util/apiUtils";

/** Tries a customer gets at drawing one photo again (the API enforces the same limit). */
export const MAX_DRAW_RETRIES = 2;

/** True when a cover or page photo has used its "Try again"s and needs a different photo. */
export const drawRetriesUsedUp = (img) => (img?.drawRetries || 0) >= MAX_DRAW_RETRIES;

/**
 * "Try again" on a cover or pages that failed to draw (API POST runpod/retry).
 * Resolves { ok, code } where code is "RETRY_LIMIT" when the photo has used its
 * tries (ask for a different photo), "IN_PROGRESS" while pages draw.
 */
export async function retryDrawing({ bookId, cover = false, mediaIds = [] }) {
  const res = await apiRequest("post", "runpod/retry", { body: cover ? { bookId, cover: true } : { bookId, mediaIds } });
  const body = res?.data || {};
  return { ok: !!res && res.status < 400 && body.success !== false, code: body.code || null, message: body.message || null };
}
